// src/encounter/wrap-up-follow-up.tsx
// FOLLOW-UP scheduler slice — thin adapter over the DS FollowUpDurationInput (1.50.0,
// built from the E2 wrap-up node 1736:159106). External contract unchanged (backend
// casing 'Days'|'Weeks'|...); the DS control speaks lowercase units — casing is
// translated HERE at the boundary, nowhere else.
import { FollowUpDurationInput, type FollowUpUnit as DsFollowUpUnit } from '@scripsteam/scrips-signal-ds';
import type { FollowUpUnit } from '@/types/wrap-up-api';

export interface WrapUpFollowUpProps {
  /** 0 = no follow-up scheduled. */
  count: number;
  unit: FollowUpUnit;
  onChange: (next: { count: number; unit: FollowUpUnit }) => void;
  /** Persisting — disables the controls (also guards against a duplicate-create race). */
  saving?: boolean;
  /** Not yet loaded — disable until the wrap-up GET settles, so an edit before we know the
   *  existing record can't POST a duplicate (it would omit the id). */
  disabled?: boolean;
  /** Frame v2, inside the note (signal-ds 2.20, PROD-3009): AA labels and 24px targets. Absent → as before. */
  inNote?: boolean;
}

const toDs = (u: FollowUpUnit): DsFollowUpUnit => u.toLowerCase() as DsFollowUpUnit;
const fromDs = (u: DsFollowUpUnit): FollowUpUnit =>
  (u.charAt(0).toUpperCase() + u.slice(1)) as FollowUpUnit;

export function WrapUpFollowUp({ count, unit, onChange, saving, disabled, inNote }: WrapUpFollowUpProps) {
  return (
    <FollowUpDurationInput
      label="Follow-Up"
      value={{ count, unit: toDs(unit) }}
      onChange={(v) => onChange({ count: v.count, unit: fromDs(v.unit) })}
      disabled={saving || disabled}
      {...(inNote ? { labelTone: 'secondary' as const, targetSize: 24 as const } : {})}
    />
  );
}
